<template>
  <div class="container-fluid im-fluid" @click="$root.hideMenu">
    <h2 class="im-title">{{ $t("breadcrumbs.refunds") }}</h2>

    <div class="row">
      <div class="col-12 col-sm-12 col-xl-9">
        <a name="1"></a>

        <p>
          <strong>Refund Policy (No Refund)</strong>
        </p>

        <p>
          All products are sold “as is”. You assume the responsibility for your purchase, and no
          refunds will be issued.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "RefundsPolicySection",
  };
</script>
